export default __webpack_public_path__ + "static/media/wave2.e65360c0.svg";